
  document.addEventListener("DOMContentLoaded", function() {
    const hamburger = document.querySelector(".hamburger");
    const navMenu = document.querySelector(".nav-menu");
    hamburger.addEventListener("click", function() {
      navMenu.style.display = navMenu.style.display === "block" ? "none" : "block";
    });
  });



document.addEventListener("DOMContentLoaded", function() {
  const slides = document.querySelectorAll(".slide");
  const dots = document.querySelectorAll(".dot");
  let index = 0;
  let autoSlide;

  function showSlide(i) {
    slides.forEach((slide, idx) => {
      slide.classList.toggle("active", idx === i);
    });
    dots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === i);
    });
    document.querySelector(".slider-wrapper").style.transform =
      `translateX(-${i * 100}%)`;
    index = i;
  }

  function startAutoSlide() {
    autoSlide = setInterval(() => {
      let next = (index + 1) % slides.length;
      showSlide(next);
    }, 15000); // 15s interval
  }

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      showSlide(i);
      clearInterval(autoSlide);
      startAutoSlide();
    });
  });

  if (slides.length > 1) startAutoSlide();
});



document.addEventListener("DOMContentLoaded", function(){
  const carousel = document.querySelector(".product-carousel");
  document.querySelector(".carousel-prev").addEventListener("click", () => {
    carousel.scrollBy({ left: -250, behavior: 'smooth' });
  });
  document.querySelector(".carousel-next").addEventListener("click", () => {
    carousel.scrollBy({ left: 250, behavior: 'smooth' });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  /* ===== LEFT: paginate SMT products (5 per page) ===== */
  (function(){
    const items = Array.from(document.querySelectorAll('.tk-smt-item'));
    const pageSize = 6;
    let page = 0;
    if (!items.length) return;
    const totalPages = Math.ceil(items.length / pageSize);

    function showPage(p) {
      page = ((p % totalPages) + totalPages) % totalPages; // wrap safely
      items.forEach((el, i) => {
        el.style.display = (i >= page * pageSize && i < (page+1) * pageSize) ? 'flex' : 'none';
      });
    }
    // init
    showPage(0);

    // left nav
    const prevBtn = document.querySelector('.tk-left-prev');
    const nextBtn = document.querySelector('.tk-left-next');
    if (prevBtn) prevBtn.addEventListener('click', () => { showPage(page - 1); });
    if (nextBtn) nextBtn.addEventListener('click', () => { showPage(page + 1); });
  })();

  /* ===== RIGHT: filter switching and carousel navigation ===== */
  (function(){
    const filterBtns = Array.from(document.querySelectorAll('.tk-filter-btn'));
    const carousels = Array.from(document.querySelectorAll('.tk-collection-carousel'));
    const prev = document.querySelector('.tk-right-prev');
    const next = document.querySelector('.tk-right-next');

    function setActiveCollection(handle) {
      carousels.forEach(c => {
        const isActive = c.getAttribute('data-collection') === handle;
        c.setAttribute('data-active', isActive ? 'true' : 'false');
      });
      filterBtns.forEach(b => b.classList.toggle('is-active', b.dataset.collection === handle));
      // scroll first item into view on switch (optional)
      const activeInner = document.querySelector('.tk-collection-carousel[data-active="true"] .tk-carousel-inner');
      if (activeInner && activeInner.children.length) activeInner.scrollLeft = 0;
    }

    // attach click to filter buttons
    filterBtns.forEach(btn => {
      btn.addEventListener('click', function(){
        const handle = this.dataset.collection;
        setActiveCollection(handle);
      });
    });

    // initial ensure (first active)
    if (filterBtns.length) setActiveCollection(filterBtns.find(b => b.classList.contains('is-active'))?.dataset.collection || filterBtns[0].dataset.collection);

    // carousel prev/next operate on currently visible carousel
    function scrollActiveCarousel(delta) {
      const active = document.querySelector('.tk-collection-carousel[data-active="true"] .tk-carousel-inner');
      if (!active) return;
      active.scrollBy({ left: delta, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', () => scrollActiveCarousel(-300));
    if (next) next.addEventListener('click', () => scrollActiveCarousel(300));
  })();
});



document.querySelectorAll('.feature-card').forEach(card => {
  const hoverColor = card.getAttribute('data-hover');
  card.style.setProperty('--hover-color', hoverColor);
});


<!-- 6. js for disk and blander -->

document.addEventListener('DOMContentLoaded', function () {
  const pages = Array.from(document.querySelectorAll('.db-product-page'));
  const nextBtn = document.querySelector('.db-next-btn');
  const prevBtn = document.querySelector('.db-prev-btn');

  if (!pages.length) return;

  let current = 0;

  function updateUI() {
    pages.forEach((p, i) => p.classList.toggle('active', i === current));
    prevBtn.disabled = current === 0;
    nextBtn.disabled = current === pages.length - 1;
  }

  nextBtn.addEventListener('click', () => {
    if (current < pages.length - 1) {
      current++;
      updateUI();
    }
  });

  prevBtn.addEventListener('click', () => {
    if (current > 0) {
      current--;
      updateUI();
    }
  });

  updateUI(); // show first page
});

<!-- js for google review and blog section -->



document.addEventListener("DOMContentLoaded", function(){
  // Reviews
  const reviewCards = document.querySelectorAll(".reviews-wrapper .review-card");
  let reviewIndex = 0;

  function showReview(index){
    reviewCards.forEach((card, i) => {
      card.classList.toggle("active", i === index);
    });
  }

  document.querySelector(".review-next").addEventListener("click", () => {
    reviewIndex = (reviewIndex + 1) % reviewCards.length;
    showReview(reviewIndex);
  });

  document.querySelector(".review-prev").addEventListener("click", () => {
    reviewIndex = (reviewIndex - 1 + reviewCards.length) % reviewCards.length;
    showReview(reviewIndex);
  });

  showReview(reviewIndex);
});

  // JavaScript for Toggle
document.addEventListener("DOMContentLoaded", function() {
  const toggle = document.querySelector(".mobile-menu-toggle");
  const nav = document.querySelector(".header-nav");
  if(toggle && nav){
    toggle.addEventListener("click", () => {
      nav.classList.toggle("active");
    });
  }
});document.addEventListener("DOMContentLoaded", function () {
  /* ===== 1. Hamburger Menu ===== */
  const hamburger = document.querySelector(".hamburger");
  const navMenu = document.querySelector(".nav-menu");
  if (hamburger && navMenu) {
    hamburger.addEventListener("click", function () {
      navMenu.style.display =
        navMenu.style.display === "block" ? "none" : "block";
    });
  }

  /* ===== 2. Hero Slider ===== */
  const slides = document.querySelectorAll(".slide");
  const dots = document.querySelectorAll(".dot");
  let index = 0;
  let autoSlide;

  function showSlide(i) {
    if (!slides.length) return;
    slides.forEach((slide, idx) => {
      slide.classList.toggle("active", idx === i);
    });
    dots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === i);
    });
    const wrapper = document.querySelector(".slider-wrapper");
    if (wrapper) wrapper.style.transform = `translateX(-${i * 100}%)`;
    index = i;
  }

  function startAutoSlide() {
    autoSlide = setInterval(() => {
      let next = (index + 1) % slides.length;
      showSlide(next);
    }, 15000);
  }

  if (slides.length > 1) {
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        showSlide(i);
        clearInterval(autoSlide);
        startAutoSlide();
      });
    });
    startAutoSlide();
  }

  /* ===== 3. Product Carousel ===== */
  const carousel = document.querySelector(".product-carousel");
  const prevBtn = document.querySelector(".carousel-prev");
  const nextBtn = document.querySelector(".carousel-next");
  if (carousel && prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => {
      carousel.scrollBy({ left: -250, behavior: "smooth" });
    });
    nextBtn.addEventListener("click", () => {
      carousel.scrollBy({ left: 250, behavior: "smooth" });
    });
  }

  /* ===== 4. Left/Right Paginate & Filter ===== */
  (function () {
    const items = Array.from(document.querySelectorAll(".tk-smt-item"));
    const pageSize = 6;
    let page = 0;
    if (!items.length) return;
    const totalPages = Math.ceil(items.length / pageSize);

    function showPage(p) {
      page = ((p % totalPages) + totalPages) % totalPages;
      items.forEach((el, i) => {
        el.style.display =
          i >= page * pageSize && i < (page + 1) * pageSize ? "flex" : "none";
      });
    }
    showPage(0);

    const prevBtn = document.querySelector(".tk-left-prev");
    const nextBtn = document.querySelector(".tk-left-next");
    if (prevBtn) prevBtn.addEventListener("click", () => showPage(page - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => showPage(page + 1));
  })();

  (function () {
    const filterBtns = Array.from(document.querySelectorAll(".tk-filter-btn"));
    const carousels = Array.from(
      document.querySelectorAll(".tk-collection-carousel")
    );
    const prev = document.querySelector(".tk-right-prev");
    const next = document.querySelector(".tk-right-next");

    function setActiveCollection(handle) {
      carousels.forEach((c) => {
        const isActive = c.getAttribute("data-collection") === handle;
        c.setAttribute("data-active", isActive ? "true" : "false");
      });
      filterBtns.forEach((b) =>
        b.classList.toggle("is-active", b.dataset.collection === handle)
      );
      const activeInner = document.querySelector(
        '.tk-collection-carousel[data-active="true"] .tk-carousel-inner'
      );
      if (activeInner && activeInner.children.length) activeInner.scrollLeft = 0;
    }

    filterBtns.forEach((btn) => {
      btn.addEventListener("click", function () {
        setActiveCollection(this.dataset.collection);
      });
    });

    if (filterBtns.length)
      setActiveCollection(
        filterBtns.find((b) => b.classList.contains("is-active"))?.dataset
          .collection || filterBtns[0].dataset.collection
      );

    function scrollActiveCarousel(delta) {
      const active = document.querySelector(
        '.tk-collection-carousel[data-active="true"] .tk-carousel-inner'
      );
      if (!active) return;
      active.scrollBy({ left: delta, behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", () => scrollActiveCarousel(-300));
    if (next) next.addEventListener("click", () => scrollActiveCarousel(300));
  })();

  /* ===== 5. Feature Cards Hover ===== */
  document.querySelectorAll(".feature-card").forEach((card) => {
    const hoverColor = card.getAttribute("data-hover");
    card.style.setProperty("--hover-color", hoverColor);
  });

  /* ===== 6. Disk & Blender Pagination ===== */
  const dbPages = Array.from(document.querySelectorAll(".db-product-page"));
  const dbNext = document.querySelector(".db-next-btn");
  const dbPrev = document.querySelector(".db-prev-btn");
  if (dbPages.length && dbNext && dbPrev) {
    let current = 0;

    function updateUI() {
      dbPages.forEach((p, i) => p.classList.toggle("active", i === current));
      dbPrev.disabled = current === 0;
      dbNext.disabled = current === dbPages.length - 1;
    }

    dbNext.addEventListener("click", () => {
      if (current < dbPages.length - 1) {
        current++;
        updateUI();
      }
    });

    dbPrev.addEventListener("click", () => {
      if (current > 0) {
        current--;
        updateUI();
      }
    });

    updateUI();
  }

  /* ===== 7. Reviews ===== */
  const reviewCards = document.querySelectorAll(
    ".reviews-wrapper .review-card"
  );
  let reviewIndex = 0;
  if (reviewCards.length) {
    function showReview(index) {
      reviewCards.forEach((card, i) => {
        card.classList.toggle("active", i === index);
      });
    }

    const reviewNext = document.querySelector(".review-next");
    const reviewPrev = document.querySelector(".review-prev");

    if (reviewNext)
      reviewNext.addEventListener("click", () => {
        reviewIndex = (reviewIndex + 1) % reviewCards.length;
        showReview(reviewIndex);
      });

    if (reviewPrev)
      reviewPrev.addEventListener("click", () => {
        reviewIndex = (reviewIndex - 1 + reviewCards.length) % reviewCards.length;
        showReview(reviewIndex);
      });

    showReview(reviewIndex);
  }

  /* ===== 8. Mobile Menu Toggle ===== */
  const toggle = document.querySelector(".mobile-menu-toggle");
  const nav = document.querySelector(".header-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      nav.classList.toggle("active");
    });
  }
});


